// extracted by mini-css-extract-plugin
export default {"shell":"AppShell_shell__Ngvpv","shellResumes":"AppShell_shellResumes__SnPVl","main":"AppShell_main__5nhtB"};